export default "__VITE_ASSET__29b0200e__"